/**
 * Dialog for selecting a board
 */

import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Board } from '../../modules/tasks/types';

interface BoardSelectorDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (boardId: string) => void;
  boards: Board[];
}

export function BoardSelectorDialog({
  open,
  onClose,
  onSelect,
  boards,
}: BoardSelectorDialogProps) {
  const { t } = useTranslation('common');

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-xs" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>{t('app.selectEntity', { entity: t('entities.board') })}</DialogTitle>
        </DialogHeader>
        <div className="py-2">
          <div className="space-y-1">
            {boards.map((board) => (
              <button
                key={board.id}
                onClick={() => onSelect(board.id)}
                className="flex items-center gap-3 w-full px-3 py-2 text-sm rounded-md hover:bg-accent transition-colors text-left"
              >
                <div
                  className="w-4 h-4 rounded-full shrink-0"
                  style={{ backgroundColor: board.color || undefined }}
                />
                <span className="truncate">{board.name}</span>
              </button>
            ))}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            {t('app.cancel')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
